// extracted by mini-css-extract-plugin
module.exports = {"results":"style_results__1aOZS","results__ideal":"style_results__ideal__1SNWm","results__ideal__result":"style_results__ideal__result__2EPQu"};